import { FETCH, FETCH_API_ERROR, FETCH_SUCCESS } from './actions';

const hueDevices = (state = { }, action) => {
	switch (action.type) {
	case FETCH:
		return {
			...state,
			[action.credentialsId]: {
				...state[action.credentialsId],
				isFetching: true,
				isStale: false,
			}
		};
	case FETCH_SUCCESS: {
		return {
			...state,
			[action.credentialsId]: {
				...state[action.credentialsId],
				lights: action.payload.data.map(player => ({
					name: player.metadata.name,
					uuid: player.id
				})),
				isFetching: false,
			}
		};
	}
	case FETCH_API_ERROR: {
		return {
			...state,
			[action.credentialsId]: {
				...state[action.credentialsId],
				isFetching: false,
			}
		};
	}
	default:
		return state;
	}
};

export default hueDevices;
